export const ro = {
  languages: {
    english: "Engleză",
    spanish: "Spaniolă",
    dutch: "Olandeză",
    french: "Franceză",
    portuguese: "Portugheză",
    italian: "Italiană",
    german: "Germană",
    polish: "Poloneză",
    romanian: "Română",
    greek: "Greacă",
    //TODO: add new language here
  },
  loginPage: {
    title: "Autentificare",
    email: "Email",
    placeholder: "Introduceți adresa de email",
    buttonText: "Autentificare",
    loginMessage:
      "Un email a fost trimis la adresa de email furnizată. Vă rugăm să faceți clic pe linkul din email pentru a vă autentifica.",
    noEmailMessage:
      "Vă rugăm să utilizați linkul din emailul care v-a fost trimis pentru a declanșa acest proces.",
  },
  formPage: {
    title: "Revizuire periodică",
    submittedMessage: "Formularul a fost trimis!",
    alreadySubmittedMessage:
      "Formularul a fost deja trimis! Dacă doriți să modificați informațiile trimise anterior, vă rugăm să contactați managerul de relații.",
    waitMessage: "Se încarcă datele, vă rugăm așteptați...",
    asteriskMessage1: "Vă rugăm să completați toate câmpurile cu",
    asteriskMessage2: "deoarece sunt obligatorii.",
    savedLocallyMessage:
      "Toate modificările vor fi salvate local pe dispozitivul dumneavoastră.",
    accessFormAgain: "Puteți accesa din nou formularul folosind linkul",
    openPRs: "Revizuiri periodice deschise",
    addRelation: "Adăugare relație",
    submit: "Trimite",
    continue: "Continuă",
    addFile: "Adaugă fișier",
  },
};
